import { apiConfig } from '../apiConfig';
import { addCommonHeaders, handleResponse, handleErrors } from '../apiUtils';

export default {

    show: async (missionId, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/mission_user_list";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    create: async (missionId, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/mission_user_lists";

        const body = {
            mission_id: missionId
        }

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: addCommonHeaders(),
                credentials: 'include',
                body: JSON.stringify(body)
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    }
}